import { render, staticRenderFns } from "./base-checkbox.vue?vue&type=template&id=72ba8229&scoped=true&"
import script from "./base-checkbox.vue?vue&type=script&lang=js&"
export * from "./base-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./base-checkbox.vue?vue&type=style&index=0&id=72ba8229&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ba8229",
  null
  
)

export default component.exports